import { useSyncExternalStore } from 'react';

/**
 * Tiny global store for the "Cash paid out" dialog. Anything (a POS button, a menu, a test) can call
 * `openCashPayout()`; the dialog itself is mounted by <AppLayout/> (via <CashPayoutHost/>), which also
 * registers the Alt+E shortcut.
 */
let open = false;
const listeners = new Set<() => void>();

function set(next: boolean) {
  if (open === next) return;
  open = next;
  listeners.forEach((l) => l());
}

export function openCashPayout(): void {
  set(true);
}
export function closeCashPayout(): void {
  set(false);
}
export function isCashPayoutOpen(): boolean {
  return open;
}

export function useCashPayoutOpen(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => open,
    () => false,
  );
}
